import { Box, Stack } from '@chakra-ui/react';
import Colors from '../../../../../config/colors';

interface Props {
    names: string[];
}

export default function ProductSectionList({ names }: Props) {
    return (
        <Stack
            direction="row"
            whiteSpace="nowrap"
            spacing="10px"
            color={Colors.lightBlue}
            overflow="scroll"
            style={{ scrollbarWidth: 'none' }}>
            {names.map((name) => (
                <Box padding="5px 20px" borderRadius="5px" bg={Colors.darkBlue2}>
                    {name}
                </Box>
            ))}
        </Stack>
    );
}
